import baseAction from './_base';
import {ERROR_BAD_EMAIL} from './actionTypes';

export function errorBadEmail() {
  return baseAction(ERROR_BAD_EMAIL, '/v1/contact/sales/errorBadEmail');
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/errorBadEmail.js
 **/